export default __webpack_public_path__ + "static/media/banner-1.627e8b0a.png";